import React, { useState, useEffect } from "react";
import SidebarItem from "./SidebarItem";
import sidebarStyle from "./UpdateSidebarMenu.module.css";

const decodeJWT = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const atob_result = atob(base64);
    const jsonPayload = decodeURIComponent(
      atob_result
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

const SidebarList = ({
  items,
  onItemClick,
  activeItemId,
  appData,
  isGrouped = false,
  showSteps = false,
}) => {
  const [filteredItems, setFilteredItems] = useState(items);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const decoded = token ? decodeJWT(token) : null;

    if (decoded?.is_support) {
      const userRoles = decoded.user_roles || [];
      const filtered = items.filter(
        (item) =>
          !item.permitted_to ||
          item.permitted_to.some((role) => userRoles.includes(role))
      );
      setFilteredItems(filtered);
    } else {
      setFilteredItems(items);
    }
  }, [items]);

  if (filteredItems.length === 0) {
    return null;
  }

  // Only show steps if there are more than 1 item AND showSteps is true
  const shouldShowSteps = showSteps && filteredItems.length > 1;

  return (
    <ul className={isGrouped ? sidebarStyle.groupedList : sidebarStyle.sidebarList}>
      {filteredItems.map((item) => {
        const isActive = activeItemId === item.text;
        const isCompleted = false;
        
        return (
          <li key={item.id}>
            <SidebarItem
              text={item.text}
              icon={item.icon}
              active={isActive}
              completed={isCompleted}
              onClick={() => onItemClick(item)} // Pass the item object
              showSteps={shouldShowSteps}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default SidebarList;